<script setup lang="ts">
import ListConsoleName from "@/components/lists/list-console-name.vue";

defineProps<{
  consoleId: string;
}>();
</script>

<template>
  <section class="tab-console">
    <div class="content">
      <list-console-name :owner-id="consoleId" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-console {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-console {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
